import Core from './core'
import Control from './control'
import Player from './player'
import Terrain from './terrain'
import UI from './ui'
import Audio from './audio'
import Mobs from './mobs'
import Drops from './drops'

import './style.css'

const core = new Core()
const camera = core.camera
const scene = core.scene
const renderer = core.renderer

const player = new Player()
const audio = new Audio(camera)

const terrain = new Terrain(scene, camera)
const control = new Control(scene, camera, player, terrain, audio, core)

const ui = new UI(terrain, control)
control.setBag(ui.bag)
control.setChest(ui.chest)
const mobs = new Mobs(scene, camera, terrain)
control.setMobs(mobs)
ui.setMobs(mobs)
const drops = new Drops(camera, ui.bag)
control.setDrops(drops)
ui.setDrops(drops)

// animation
;(function animate() {
  // let p1 = performance.now()
  requestAnimationFrame(animate)

  core.update()
  control.update()
  terrain.update()
  mobs.update()
  drops.update()
  ui.update()

  renderer.render(scene, camera)
  // console.log(performance.now()-p1)
})()
